/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, June 29th 2022, 7:33:24 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { EmptyStateActionWrapper, Image } from "ui-widgets";

export const EmptyFormsCTA = ({ noDataMessage, ctaButtons }) => {
  return (
    <>
      <EmptyStateActionWrapper
        title="No forms created yet"
        description={noDataMessage}
        illustrationGraphic={<Image className="image-style-A" src="/img/office.png" alt="Onestop Admin" />}
      >
        {ctaButtons}
      </EmptyStateActionWrapper>
    </>
  );
};
